module.exports = __webpack_public_path__ + "img/xlsx.f847910f.svg";